var _rect, _rect2, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductivityimg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "url(#paint0_linear_852_1246)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "url(#paint1_linear_852_1246)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6153 21.256C28.4942 21.7089 23.2907 22.1255 23.046 22.1742C22.36 22.2966 21.736 22.7619 21.4426 23.3743L21.1855 23.9131L21.2103 36.756L21.2467 49.5988L21.6385 50.3948C21.8591 50.8353 23.3526 52.8924 24.9808 55.0099C28.2008 59.1845 28.4331 59.4176 29.6571 59.5399C30.0125 59.5763 32.6812 59.454 35.5707 59.2829C38.4725 59.0994 43.124 58.8176 45.9159 58.6588C57.8397 57.9349 57.2273 57.9961 57.9125 57.4085C58.7696 56.6985 58.7084 57.8614 58.7448 42.2522C58.7696 29.0176 58.7572 28.1489 58.5613 27.7448C58.329 27.2919 57.9125 26.9737 52.4766 23.1536C48.8409 20.6072 48.5838 20.4725 46.9549 20.4477C46.2821 20.4237 40.7239 20.7907 34.6153 21.256ZM48.3756 22.933C48.8897 23.1652 52.6485 25.7852 53.199 26.2877C53.3461 26.4348 53.3949 26.5571 53.3213 26.6307C53.1502 26.7778 29.8886 28.1613 29.2158 28.063C28.91 28.0142 28.4571 27.8307 28.2 27.6588C27.1347 26.9365 24.4907 24.7694 24.4907 24.6107C24.4907 24.1942 24.4048 24.1942 34.7748 23.4478C36.7583 23.3131 40.0147 23.0685 41.9983 22.909C46.2945 22.566 47.5804 22.5784 48.3756 22.933ZM55.7702 29.63C55.9413 29.8011 56.0884 30.1317 56.1372 30.4499C56.1736 30.7441 56.1983 36.2287 56.1736 42.6192C56.1372 53.5884 56.1248 54.2744 55.9165 54.5926C55.7942 54.7885 55.5495 54.9967 55.3653 55.0579C54.852 55.2662 30.477 56.6497 29.9753 56.5026C29.7431 56.4415 29.4241 56.2456 29.253 56.0745L28.9588 55.7563L28.9224 43.93C28.8976 35.6295 28.9224 31.9566 29.0207 31.626C29.0943 31.3813 29.2778 31.0871 29.4372 30.9896C29.6579 30.8425 31.1026 30.7201 36.0731 30.4267C39.5626 30.2308 44.9612 29.9002 48.0589 29.7167C55.4272 29.263 55.4032 29.263 55.7702 29.63Z",
    fill: "#A6A6C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2198 33.6823C47.8974 33.7682 46.7221 33.8906 46.5874 33.9641C46.1833 34.1724 45.9386 34.5154 45.8898 34.9071C45.8534 35.3113 45.9758 35.36 47.2974 35.5195L47.8726 35.5931V40.8207C47.8726 43.9299 47.8238 45.9871 47.7627 45.9259C47.7015 45.8523 45.9634 43.2084 43.8939 40.0495C41.8251 36.8791 40.111 34.2707 40.0862 34.2467C40.0615 34.2219 38.7151 34.2955 37.0993 34.4062C35.1157 34.5409 34.0264 34.6632 33.8057 34.7856C33.4504 34.9691 33.0586 35.6179 33.0586 36.0468C33.0586 36.3038 33.5239 36.4385 34.5033 36.4385H35.0174V51.4724L34.1851 51.7295C33.5363 51.9254 33.3156 52.0477 33.2057 52.2924C33.0098 52.7089 33.0222 53.0883 33.2181 53.0883C33.2916 53.0883 34.6752 53.0023 36.2662 52.9048C39.4127 52.7213 39.7673 52.6353 40.0979 51.9865C40.1962 51.7907 40.2813 51.5824 40.2813 51.5212C40.2813 51.4724 39.8532 51.3253 39.3383 51.203C38.8119 51.0807 38.2854 50.9584 38.1754 50.9336C37.9672 50.8724 37.9548 50.493 37.9548 45.2283V39.5842L41.6765 45.4242C45.5817 51.5452 46.0718 52.2436 46.6718 52.5494C47.4189 52.9412 49.3166 52.6717 50.2712 52.0477L50.5654 51.8642L50.5902 43.515L50.6265 35.1533L51.2753 35.031C52.0465 34.8839 52.4018 34.5293 52.4018 33.9169C52.4018 33.5251 52.3771 33.5003 52.0101 33.5127C51.791 33.5228 50.5298 33.5964 49.2198 33.6823Z",
    fill: "#A6A6C9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_852_1246",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05050F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8DB9",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_852_1246",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27273F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductivityimg7);
export default __webpack_public_path__ + "static/media/productivityimg7.7a149e291b8ef19200afd873af37295f.svg";
export { ForwardRef as ReactComponent };